export const SITE = {
  url: "https://extremeteambuilding.cz",
  name: "Extreme Teambuilding",
  descriptor: "by Warehouse Liberec",
  product: "Mission Ještěd",
  email: "warehouseklub@gmail.com",
  phone: "+420 736 780 770",
  company: "Warehouse club Liberec s.r.o.",
  address: "Hanychovská 328/10, 460 07 Liberec",
  addressShort: "Hanychovská 10, Liberec",
  ico: "19829451",
  dic: "CZ19829451",
  groupRange: "20–50 lidí",
  priceFrom: "od 4 990 Kč / osoba",
};

export const NAV = [
  { href: "/mission-jested", label: "Mission Ještěd" },
  { href: "/jak-to-funguje", label: "Jak to funguje" },
  { href: "/cenik", label: "Ceník" },
  { href: "/pruvodce", label: "Průvodce" },
  { href: "/kontakt", label: "Kontakt" },
];

export const FOOTER_COLS = [
  {
    heading: "Produkt",
    links: [
      { href: "/mission-jested", label: "Mission Ještěd" },
      { href: "/jak-to-funguje", label: "Jak to funguje" },
      { href: "/cenik", label: "Ceník" },
      { href: "/warehouse-party", label: "Warehouse party" },
      { href: "/ubytovani", label: "Ubytování" },
      { href: "/bezpecnost", label: "Bezpečnost" },
    ],
  },
  {
    heading: "Pro firmy",
    links: [
      { href: "/pro-firmy", label: "Pro firmy" },
      { href: "/firemni-teambuilding", label: "Firemní teambuilding" },
      { href: "/teambuilding-s-ubytovanim", label: "Teambuilding s ubytováním" },
      { href: "/teambuilding-praha", label: "Teambuilding Praha" },
      { href: "/teambuilding-liberec", label: "Teambuilding Liberec" },
      { href: "/pripadove-studie", label: "Případové studie" },
    ],
  },
  {
    heading: "Týmy a formáty",
    links: [
      { href: "/teambuilding-pro-20-lidi", label: "Pro 20 lidí" },
      { href: "/teambuilding-pro-30-lidi", label: "Pro 30 lidí" },
      { href: "/teambuilding-pro-50-lidi", label: "Pro 50 lidí" },
      { href: "/outdoor-teambuilding", label: "Outdoor teambuilding" },
      { href: "/vikendovy-teambuilding", label: "Víkendový teambuilding" },
      { href: "/teambuilding-s-party", label: "Teambuilding s party" },
    ],
  },
  {
    heading: "Informace",
    links: [
      { href: "/pruvodce", label: "Průvodce" },
      { href: "/o-nas", label: "O nás" },
      { href: "/kontakt", label: "Kontakt" },
      { href: "/obchodni-podminky", label: "Obchodní podmínky" },
      { href: "/ochrana-osobnich-udaju", label: "Ochrana osobních údajů" },
      { href: "/cookies", label: "Cookies" },
    ],
  },
];
